import React from "react";
import axios from "axios";
// import { toHaveDisplayValue } from "@testing-library/jest-dom/dist/matchers";

export default function WebappSystem(props) {

    const x = props.x;
	const renderCount = React.useRef(1);
	const defaultAction = () => { return false; };

	// Webapp Version
	x.was.version = '1.1';
	x.was.buildNo = 0; 	                                              		// Wird über init in App.js gesetzt


	// Variables
	x.was.imageFullSize = null;
	x.was.smilies = {};
	x.was.smilieCategories = {};
	x.was.smiliesSortTranslation = null;
	x.was.members = {};
	x.was.topics = {};
	x.was.foren = {};														// Wird einmalig beim Start geladen (siehe getSystemData), Schlüssel = forumid
	x.was.postingsUnread = {'forum':0, 'admin':0};						// Wird in MemberListBasis und Postings gesetzt
	x.was.postingsLastUnread = {'forum':0, 'admin':0};					// Wird in MemberListBasis und Postings gesetzt
	x.was.postingsUnreadHint = [];										// Wird in MemberListBasis und Postings gesetzt. 
	x.was.postingsUnreadCount = 0;										// Wird in dieser Komponenten in der Funktion setFavicon gesetzt
	x.was.postingUnshrink = []											// Wird in der Komponente Posting gesetzt und enthält die postingno eines großen Postings, das komplett angezeigt wird. 
	x.was.privatePostingsUnreadCount = 0;									// Wird in dieser Komponenten in der Funktion setFavicon gesetzt
	x.was.webSocket = null;												// Wird in der Komponente WebappWebSocket gesetzt
	x.was.logTimout = null;												// Handle auf Timeout-Funktion. Wird in der Funktion errorLog gesetzt
	x.was.loadMemberListTimeOut = null;									// Handle auf Timeout-Funktion. Wird in der Funktion loadMemberList der Komponente MemberListBasis gesetzt



	// Functions
	x.was.activateNavigation = defaultAction;								// Wird in der Komponente Webapp gesetzt
	x.was.addHint = defaultAction;
	x.was.addNewThread = addNewThread;
	x.was.axGet = axGet;
	x.was.axPost = axPost;
	x.was.getMemberList = defaultAction;									// Wird in der Komponente MemberListBasis gesetzt
	x.was.getTime = getTime;
	x.was.getProjectInfo = getProjectInfo;
	x.was.isAdmin = isAdmin;
	x.was.isMobileDevice = isMobileDevice;
	x.was.loadSoftwareUpdate = loadSoftwareUpdate;
	x.was.makeMemberList = defaultAction;									// Wird in der Komponente MemberListBasis gesetzt
	x.was.onClick = onClick;
	x.was.sendSmiliesUpdate = sendSmiliesUpdate;
	x.was.sendSoftwareUpdate = sendSoftwareUpdate;
	x.was.setFavicon = setFavicon;
	x.was.setSmilies = setSmilies;
	x.was.reportError = reportError;
	x.was.updatePostingsUnread = updatePostingsUnread;
	x.was.logout = logout;
	x.was.unlock = unlock;
	x.was.getPushSubscriptionStatus = getPushSubscriptionStatus;
	x.was.enablePush = enablePush;
	x.was.disablePush = disablePush;
	x.was.webAppLoaded = defaultAction;									// Wird in der Komponente Webapp gesetzt

	x.was.hostName = document.location.hostname;
	x.was.webapp = 0;                                                   	// Wird in Content.js und NavigationTop.js im useEffect-Hook gesetzt. 0: nicht gerendert, 1: ohne Module und Blöcke gerendert, 2: mit Module und Blöcke gerendert

	// Level 1=root, 2=admin, 3=user, 4=guest
	x.was.memberLevel = 4;												// Wird in app.js in der Function webappRendered gesetzt.  	
	x.was.memberLevelLabel = ['', 'Admin', 'Moderator', 'User', 'Read Only'];
	x.was.avatarImage = '';												// Wird in MemberListBasis in der Funktion makeMemberList gesetzt
	x.was.memberId = -1;													// Wird in app.js in der Function webappRendered gesetzt. 	
	x.was.memberName = '';												// Wird in app.js in der Function webappRendered gesetzt.
	x.was.avatarText = 'X';												// Wird in app.js in der Function webappRendered gesetzt.

	React.useEffect(() => {

		if (renderCount.current === 1) {
			const getSystemData = async () => {
				/*
				let url = 'Backend/webapp.php?module=Member&task=GetMembers';
				let result = await axios.get(url);
				x.was.members = JSON.parse(result.data.content);
				*/

				let url = 'Backend/webapp.php?module=Posting&task=GetTopics';
				let result = await axios.get(url);
				x.was.topics = JSON.parse(result.data.content);
				// console.log(x.was.topics);

				x.was.foren = {}; // wird nach erfolgreichem Login in Webapp.js->webappRendered() befuellt

				props.childRendered();
			};
			getSystemData();
		}
		renderCount.current++;
	});

	// System Labels
	x.was.application = 'Forum';                                        		// Wird über init in App.js gesetzt

	// Settings
	x.was.darkTheme = false;                                             		// Wird über init in App.js gesetzt
	x.was.darkThemeVariant = false;                                      		// Wird über init in App.js gesetzt
	x.was.forumClass = '';	                                           		// Wird über init in App.js gesetzt
	x.was.forumHideContent = 'd-block';	                               		// Wird über init in App.js gesetzt
	x.was.forumHideDiscussion = 'd-block';                             		// Wird über init in App.js gesetzt
	x.was.forumHideImages = '';			                               		// Wird über init in App.js gesetzt
	x.was.forumHideOT = 'd-block';	         	                      		// Wird über init in App.js gesetzt
	x.was.forumHideAvatar = true;         	                      			// Wird über init in App.js gesetzt
	x.was.forumHideDate = 'd-block';	         	                      		// Wird über init in App.js gesetzt
	x.was.forumMemberColored = 0;		         	                      		// Wird über init in App.js gesetzt
	x.was.forumFontBold = 0;			         	                      		// Wird über init in App.js gesetzt
	x.was.forumFontSize = 0;			         	                      		// Wird über init in App.js gesetzt
	x.was.forumSendWithEnter = 0;			         	                      	// Wird über init in App.js gesetzt

	// System Functions

	x.was.loadActiveMember = defaultAction	                        			// Zeigt auf die Function "makeActiveList" aus der MemberList-Komponente und wird aus dieser gesetzt.  
	x.was.activateNavigation = defaultAction;									// Zeigt auf die Function "activateNavigation" aus Webapp.js. Wird in Webapp.js gesetzt. 
	x.was.addModule = defaultAction;                      	         			// Zeigt auf die Function "addModule" aus Webapp.js. Wird in Webapp.js gesetzt. 
	x.was.addNavigation = defaultAction;                      		      		// Zeigt auf die Function "addNavigation" aus Webapp.js. Wird in Webapp.js gesetzt. 
	x.was.setModal = defaultAction;				                    			// Zeigt auf die Function "modal" aus Modal.js. Wird in Modal.js gesetzt. 
	x.was.renderForum = defaultAction;                            				// Zeigt auf die Function "updateForum" aus Webapp.js. Wird in Webapp.jss gesetzt. 
	x.was.removeModule = defaultAction;                            				// Zeigt auf die Function "removeModule" aus Webapp.js. Wird in Webapp.jss gesetzt. 
	// x.was.showMemberList = false;                                     			// Wird in App.js gesetzt, sobald sich die Größe des Fensters ändert. 

	function updatePostingsUnread() {
		const currentModule = x.wam.current;
		setPostingsUnread();
		// x.was.renderForum();
		for (const key in x.was.postingsUnread) {
			if ((key !== 'forum' && key !== 'admin' ) && typeof x.wam[key] === 'undefined') {
				const memberId = x.wau.getConversationalPartner(key);
				if(typeof x.was.members[memberId] !== 'undefined') {
					x.wam.openPrivateForum(memberId, x.was.members[memberId].name, x.was.members[memberId].level, false);
				}
			}
		}
		if (currentModule !== x.wam.current) {
			x.wam.activate(currentModule);
		}
	}

	function setFavicon(hRef) {
		// Nur den href des bestehenden <link>-Elements zu aendern, reicht bei
		// Chrome unter macOS oft nicht aus - der Tab zeigt dann weiterhin das
		// alte Icon, obwohl href korrekt gesetzt ist (bekannter Browser-Quirk).
		// Zuverlaessig ist stattdessen, ein komplett NEUES <link>-Element
		// einzufuegen und das alte zu entfernen, statt das bestehende nur zu
		// aktualisieren.
		const oldFavicon = document.getElementById("favicon");
		const newFavicon = document.createElement("link");
		newFavicon.id = "favicon";
		newFavicon.rel = "icon";
		newFavicon.href = hRef;
		if (oldFavicon) {
			oldFavicon.parentNode.insertBefore(newFavicon, oldFavicon);
			oldFavicon.remove();
		}
		else {
			document.head.appendChild(newFavicon);
		}
	}

	function setPostingsUnread() {
		x.was.postingsUnreadCount = 0;
		x.was.privatePostingsUnreadCount = 0;
		for (const key in x.was.postingsUnread) {
			x.was.postingsUnreadCount += x.was.postingsUnread[key];
			x.was.privatePostingsUnreadCount = (key !== 'forum') ? x.was.privatePostingsUnreadCount += x.was.postingsUnread[key] : x.was.privatePostingsUnreadCount;
        }
		const projectInfo = getProjectInfo();
		const hRef = (x.was.postingsUnreadCount > 0)
			? getFaviconHintSrc(projectInfo.domainName, x.was.postingsUnreadCount)
			: projectInfo.srcFavicon;
		setFavicon(hRef);
		document.title = x.was.application + ' (' + x.was.postingsUnreadCount + ' ungelesene Beiträge)';
		updateAppBadge();
	}

	// Web-Badging-API: zeigt eine Zahl direkt am App-Icon an - Dock (macOS/
	// Windows-Taskleiste) und Homescreen-Icon bei installierter PWA (Android
	// Chrome, iOS ab 16.4 bei "Zum Home-Bildschirm hinzufuegen"). Rein
	// clientseitig, kein Push-Server-Umweg noetig. Nicht ueberall unterstuetzt
	// (z.B. Firefox, aeltere iOS-Versionen) - Feature-Check schuetzt davor.
	function updateAppBadge() {
		if (!('setAppBadge' in navigator)) return;
		if (x.was.postingsUnreadCount > 0) {
			navigator.setAppBadge(x.was.postingsUnreadCount).catch(() => {});
		}
		else {
			navigator.clearAppBadge().catch(() => {});
		}
	}

	function setSmilies(smilies) {
		smilies = JSON.parse(smilies);
		const smiliesSelect = {};
		const smilieCategories = {};
		Object.entries(smilies).forEach(([key, value]) => {
			// "category" ist ein eigener Schluessel innerhalb desselben Objekts
			// (siehe Session.inc::readSmilies), nicht ein Smiley-Code - hier
			// getrennt herausziehen statt wie die restlichen Eintraege als Code
			// zu behandeln.
			const category = value.category ?? null;
			Object.entries(value).forEach(([code, image]) => {
				if (code === 'category') return;
				// console.log('code: ' + code + ' - image: ' + image);
				smiliesSelect[code] = image;
				smilieCategories[code] = category;
			});
		});
		x.was.smilies = smiliesSelect;
		x.was.smilieCategories = smilieCategories;
		// console.log(x.was.smilies);
	}
	function axGet(url, handleResult) {
		// url = document.location.href + url;
		axios.get(x.wau.getUrl(url))
			.then(result => {
				handleResult(result);
			});
	}

	function axPost(url, data, handleResult, onError) {
		// console.log(data);
		axios.post(x.wau.getUrl(url), data)
			.then(result => {
				handleResult(result);
			})
			.catch(error => {
				console.error('axPost fehlgeschlagen: ' + url, error);
				if (typeof onError === 'function') onError(error);
			});
	}

	function urlBase64ToUint8Array(base64String) {
		const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
		const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
		const rawData = window.atob(base64);
		return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
	}

	function getPushSubscriptionStatus(callback) {
		if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
			callback(false, false);
			return;
		}
		navigator.serviceWorker.ready.then((registration) => {
			registration.pushManager.getSubscription().then((subscription) => {
				callback(true, !!subscription);
			});
		});
	}

	function enablePush(onDone) {
		Notification.requestPermission().then((permission) => {
			if (permission !== 'granted') {
				onDone(false);
				return;
			}
			navigator.serviceWorker.ready.then((registration) => {
				registration.pushManager.subscribe({
					userVisibleOnly: true,
					applicationServerKey: urlBase64ToUint8Array(x.was.vapidPublicKey),
				}).then((subscription) => {
					axPost('Backend/webapp.php?module=Member&task=SavePushSubscription', subscription.toJSON(), (result) => {
						onDone(result.data.returncode === 1);
					});
				}).catch(() => {
					onDone(false);
				});
			});
		});
	}

	function disablePush(onDone) {
		navigator.serviceWorker.ready.then((registration) => {
			registration.pushManager.getSubscription().then((subscription) => {
				if (!subscription) {
					onDone(true);
					return;
				}
				const endpoint = subscription.endpoint;
				subscription.unsubscribe().then(() => {
					axPost('Backend/webapp.php?module=Member&task=DeletePushSubscription', { endpoint: endpoint }, () => {
						onDone(true);
					});
				});
			});
		});
	}

	function isAdmin() {
		if (x.was.memberLevel < 3) {
			return true;
		}
		else {
			return false;
		}
	}

	function reportError(message) {
		addNewThread('admin', 0, message.stack)
	}	

	// Zurueck auf reine Viewport-Breite (Revert 2026-08-04, siehe
	// NavigationLeft.css): ein kurzer Versuch, hier stattdessen die
	// tatsaechliche Geraetegroesse zu verwenden (fuer Tablets mit hoher
	// Pixeldichte wie das Galaxy Tab S10 FE), fuehrte dazu, dass bei
	// tatsaechlich schmaler CSS-Breite die fuer breite Bildschirme gedachte
	// Oberflaeche nicht mehr in den verfuegbaren Platz passte (Sidebar
	// gequetscht, ueberlappende Kopfzeile, Bugreport per Screenshot). Fuer
	// Layout-Entscheidungen zaehlt durchgehend der tatsaechlich verfuegbare
	// Platz, nicht der Geraetetyp.
	function isMobileDevice() {
		return ((document.body.clientWidth < 1024) ? true : false);
	}
	function getTime(date) {
		if (date === undefined) {
			date = new Date();
		}
		let time = (date.getHours() < 10 ? '0' : '') + date.getHours() + ':';
		time += (date.getMinutes() < 10 ? '0' : '') + date.getMinutes() + ':';
		time += (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();
		return (time);
	}

	function getProjectInfo() {
		const info = {};
		const url = (new URL(window.location));
		const hostName = url.hostname.split(".");
		const domainName = hostName[hostName.length - 2] + '.' + hostName[hostName.length - 1];
		info.srcFavicon = 'project/' + domainName + '/favicon-v3.png';
		info.srcLogo = 'project/' + domainName + '/logo.png';
		info.domainName = domainName;
		return info;
	}

	// Eigene, vorgerenderte Icon-Datei je Anzahl (1-99, darueber "99plus") statt
	// eines einzelnen, unveraenderten "Punkt"-Icons - ein einzelner Punkt liess
	// nicht erkennen, WIEVIELE Beitraege ungelesen sind. Kein Rendern der Zahl
	// zur Laufzeit (z.B. via <canvas>), da fixe Bilddateien pro Instanz einfacher
	// zu pflegen sind und exakt zum jeweiligen Logo/Farbschema passen.
	function getFaviconHintSrc(domainName, count) {
		const suffix = (count > 99) ? '99plus' : String(Math.max(1, count));
		return 'project/' + domainName + '/favicon-hint-' + suffix + '.png';
	}

	function loadSoftwareUpdate() {
		localStorage.setItem('software-update', 1);
		window.location.reload();
	}

	function sendSoftwareUpdate() {
		x.was.send('software-update', {  });
	}

	function sendSmiliesUpdate() {
		x.was.send('smilies-update', {  });
		x.was.axGet('/Backend/webapp.php?module=System&task=ReloadSessionData', (result) => {
			// x.was.smilies = JSON.parse(result.data.content.smilies);
			x.was.setSmilies(result.data.content.smilies);

		});
	}

	function onClick(event) {
		const checkImageClick = (target) =>{
			if (target !== x.was.imageFullSize) {
				if (x.was.imageFullSize) {
					x.$(x.was.imageFullSize).removeClass('img-full-size');
				}
			}
		}
		const mentionTarget = event.target.closest && event.target.closest('.mention');
		if (mentionTarget && mentionTarget.dataset.memberid) {
			event.preventDefault();
			x.wam.openProfile(mentionTarget.dataset.memberid, mentionTarget.dataset.membername);
			return;
		}
		if (event.target.tagName === 'IMG' && !x.$(event.target).hasClass('smiley') && x.wam.isForum()) {
			checkImageClick(event.target);
			x.was.imageFullSize = event.target;
			if (!x.$(event.target).hasClass('img-full-size')) {
				x.$(x.was.imageFullSize).addClass('img-full-size');
			}
			else {
				x.$(x.was.imageFullSize).removeClass('img-full-size');
			}
		}
		else {
			x.$(x.was.imageFullSize).removeClass('img-full-size');
		}
		for (const key in x.was.watchClick) {
			x.was.watchClick[key](event);
		}
	}

	function logout() {
		const token = localStorage.getItem('token');
		localStorage.removeItem('token');
		let url = 'https://'.concat(document.location.hostname, '/Backend/webapp.php?module=Member&task=Logout');
		axios.post(url, { token: token }).then(result => {
			x.was.send('logout', { "module": props.moduleId, "member": x.was.memberName, "memberlevel": x.was.memberLevel });
			sessionStorage.clear();
			window.location.reload();
		});
	}

	function unlock() {
		let url = 'Backend/webapp.php?module=Posting&task=Unlock';
		axios.post(url).then(result => {
			console.log('Database unlocked');
		});
	}

	function addNewThread(forumId, topicId, posting) {
		let url = 'Backend/webapp.php?module=Posting&task=SaveNewPosting&forumId=' + forumId;
		const fields = {};
		fields['posting'] = posting;
		fields['topicid'] = topicId;
		axios.post(url, fields).then(result => {
			return (result.data.returncode > 1) ? true : false;
		});
	}

	return (
		<React.Fragment />
	);


}
